import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ContextProvider } from '@arco-design/mobile-react';
import StockAnalyzer from './components/StockAnalyzer';
import './App.css';

// 设备检测函数
const isMobileDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone'];
  const isMobileUserAgent = mobileKeywords.some(keyword => userAgent.includes(keyword));
  
  // 检查屏幕宽度
  const isMobileWidth = window.innerWidth <= 768;
  
  // 检查触摸支持
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isMobileUserAgent || (isMobileWidth && isTouchDevice);
};

// 桌面端提示组件
const DesktopWarning = () => {
  return (
    <div className="desktop-warning">
      <div className="desktop-warning-content">
        <div className="desktop-warning-icon">
          📱
        </div>
        <h2 className="desktop-warning-title">目前仅支持移动端哦</h2>
        <p className="desktop-warning-text">
          为了获得最佳体验，请使用手机或平板电脑访问本应用
        </p>
      </div>
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);
  
  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(isMobileDevice());
    };
    
    checkDevice();
    
    // 监听窗口大小变化
    window.addEventListener('resize', checkDevice);
    
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);
  
  return (
    <ContextProvider>
      <Router basename="/">
        <div className="App">
          {isMobile ? (
            <Routes>
              <Route path="/" element={<StockAnalyzer />} />
            </Routes>
          ) : (
            <DesktopWarning />
          )}
        </div>
      </Router>
    </ContextProvider>
  );
}

export default App;
